import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ItemMultiselectComponent } from './item-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ItemMultiselectComponent
    ],
    exports: [
        ItemMultiselectComponent
    ]
})
export class ItemMultiselectModule { }
